var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.device, _vm.deviceHeight],attrs:{"id":"main"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }